import { useSelector } from 'react-redux';
import { selectUpdateItemReferenceBySku } from '@client/cart/redux/cart/redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { AppState } from '@client/common/redux/store';
import { UpdateItemReference } from 'b2b-common/core/cart/api/CartTypes';

export const useCartUpdateItemReference = (sku: string): RemoteRecord<UpdateItemReference> => useSelector(
  (state: AppState) => selectUpdateItemReferenceBySku(state, sku),
);
